import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';
import {DocumentsServiceError, Guidebook} from '@guestapp/sdk';
import {toast} from 'react-toastify';

type Props = {
  groupId?: string;
};
function useFetchGuidebookGroups({groupId = ''}: Props) {
  const {getGuidebooksByGroup} = useChekinSDK();

  const result = useQuery<Guidebook[], DocumentsServiceError>(
    [QUERY_CACHE_KEYS.guidebookGroups, groupId],
    () => getGuidebooksByGroup(groupId),
    {
      enabled: Boolean(groupId),
      refetchOnWindowFocus: false,
      onError: error => {
        toast.error(error.detail[0].msg, {
          theme: 'colored',
        });
      },
    },
  );

  return result;
}

export {useFetchGuidebookGroups};
